import { download } from '@app/utils/helpers'
import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const InputEmailAPI = {
  getAll: function ({ org_id, folder_id, offset, limit, search }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/folders/${org_id}/${folder_id}/input-emails`,
      params: { search, offset, limit },
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  getById: function ({ org_id, folder_id, input_email_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/folders/${org_id}/${folder_id}/input-emails/${input_email_id}`,
    })
  },
  getMailDomain: function () {
    return axiosInstance.request({
      method: 'GET',
      url: `/mail-domain`,
    })
  },
  downloadOriginalAttachment: function ({ org_id, folder_id, file_id, file_name }) {
    return axiosInstance
      .request({
        method: 'GET',
        url: `/folders/${org_id}/${folder_id}/original-attachments/${file_id}`,
        responseType: 'blob',
      })
      .then(res => {
        download(res.data, file_name)
      })
  },
}

const cancelTokenObject = createCancelToken(InputEmailAPI)
export default InputEmailAPI
